import { ContactSection } from "@/components/Sections";
import { RevealText, Reveal } from "@/lib/motion";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function ContattiPage() {
  return (
    <div className="pt-24 pb-24">
      <section className="py-16 border-b border-[#141414]">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <Reveal>
            <Link to="/" className="font-mono-tech text-white/60 hover:text-[#ff4b00]"><ArrowLeft size={12} className="inline mr-1" />Home</Link>
          </Reveal>
          <Reveal delay={0.05}>
            <div className="num-chip my-6"><span className="dot" /> Capitolo 08 · Parliamone</div>
          </Reveal>
          <RevealText text="Contatti." className="font-display text-white text-[13vw] md:text-[8vw] leading-[0.9]" />
          <Reveal delay={0.2}>
            <p className="text-white/70 max-w-2xl mt-6 md:text-lg">
              Un tecnico Gefion ti risponde entro 24 ore lavorative. Preferisci parlare direttamente?
              Passa in officina: siamo a Budoia, provincia di Pordenone.
            </p>
          </Reveal>
        </div>
      </section>
      <ContactSection />
    </div>
  );
}
